module.exports = __webpack_public_path__ + "img/sign-39.93bf4398.jpg";